import { memo, useContext } from "react"
import { SidebarLink } from "@components"
import { UserContext } from "@context"
import classnames from "classnames"
import PropTypes from "prop-types"

const SidebarSubmenu = ({ links, isExpanded }) => {
  const { user } = useContext(UserContext)
  const availableLinks = links ? links.filter(link => !link.isAdmin || (link.isAdmin && user.clientUserRoles.admin)) : []
  
  if (availableLinks.length === 0) return null

  return (
    <div className='overflow-hidden'>
      <ul
        className={classnames("px-2 transition-max-height duration-300 max-h-0", { "mt-1 max-h-screen": isExpanded })}
      >
        {availableLinks.map(link => (
          <li key={link.id}>
            <SidebarLink
              href={link.href}
              icon={link.icon}
              id={link.id}
              subMenu={link.subMenu}
              type={link.type}
              expandable={link.expandable}
            >
              {link.caption}
            </SidebarLink>
          </li>
        ))}
      </ul>
    </div>
  )
}

SidebarSubmenu.propTypes = {
  isExpanded: PropTypes.bool,
  links: PropTypes.array,
}

export default memo(SidebarSubmenu)
